import { ref } from "vue";

export type ActivationHeroKey = "form" | "created";

const activationHeroKey = ref<ActivationHeroKey>("form");

export function useActivationHero() {
  function setActivationHero(key: ActivationHeroKey) {
    activationHeroKey.value = key;
  }

  function resetActivationHero() {
    activationHeroKey.value = "form";
  }

  return { activationHeroKey, setActivationHero, resetActivationHero };
}
